import { NameData, NameMatch } from '../types';
import { loadNameData } from './nameUtils';

export async function findNameMatches(searchName: string): Promise<NameMatch[]> {
  try {
    const nameData = await findNameInData(searchName);
    return nameData?.matches || [];
  } catch (error) {
    console.error('Error finding name matches:', error);
    return [];
  }
}

async function findNameInData(searchName: string): Promise<NameData | null> {
  const normalizedSearch = searchName.toLowerCase().trim();
  const genders: Array<'boys' | 'girls'> = ['boys', 'girls'];
  const letters = 'abcdefghijklmnopqrstuvwxyz'.split('');
  
  for (const gender of genders) {
    for (const letter of letters) {
      try {
        const names = await loadNameData(gender, letter);
        const foundName = names.find(
          name => name.name.toLowerCase() === normalizedSearch
        );
        if (foundName) return foundName;
      } catch {
        continue;
      }
    }
  }
  return null;
}

export function sortMatchesByCompatibility(matches: NameMatch[]): NameMatch[] {
  return [...matches].sort((a, b) => b.compatibility - a.compatibility);
}

export function getTopMatches(matches: NameMatch[], count: number = 3): NameMatch[] {
  return sortMatchesByCompatibility(matches).slice(0, count);
}